import { MouseEvent as ReactMouseEvent } from "react"
import cn from "classnames"

import { Img } from "ui-kit/components-branded/index"

export function Tab({
    isSelected,
    image,
    title,
    onClick,
}: {
    isSelected: boolean
    image: string
    title: string
    onClick?: (event: ReactMouseEvent<Element, MouseEvent>) => void
}) {
    return (
        <div
            className={cn("booking-online-off-offline-tabs__item", {
                "is-selected": isSelected,
            })}
            onClick={onClick}
        >
            <div className="d-flex">
                <Img src={image} className="booking__emoji" />
                {title}
            </div>
        </div>
    )
}
